import * as React from 'react';
import { Label, UIText2, UIHeading4 } from '@cian/ui-kit';
import * as style from './style.css';
import { IconFunctionalLock16 } from '@cian/ui-kit-design-tokens/icons';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const FlatCard = _ref => {
  let {
    flat,
    onClick,
    favoriteButton: FavoriteButton
  } = _ref;
  const {
    price,
    hasDecoration,
    description,
    url,
    dueDate,
    isBooked,
    discount
  } = flat;
  const discountLabel = discount === null || discount === void 0 ? void 0 : discount.discountLabel;
  const oldPrice = discount === null || discount === void 0 ? void 0 : discount.oldPrice;
  return /*#__PURE__*/_jsxs("a", {
    target: "_blank",
    rel: "noreferrer",
    href: url,
    className: style['card'],
    id: "flatcardid-".concat(flat.offerId),
    onClick: onClick,
    children: [/*#__PURE__*/_jsxs("div", {
      className: style['description'],
      children: [/*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("div", {
          className: style['date'],
          children: /*#__PURE__*/_jsx(UIText2, {
            color: "current_color",
            whiteSpace: "nowrap",
            children: dueDate
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: style['price'],
          children: [isBooked && /*#__PURE__*/_jsx("div", {
            className: style['icon'],
            children: /*#__PURE__*/_jsx(IconFunctionalLock16, {
              display: "block",
              color: "decorative-magentum"
            })
          }), /*#__PURE__*/_jsx(UIHeading4, {
            color: isBooked ? 'text-secondary-default' : 'text-primary-default',
            children: price
          }), /*#__PURE__*/_jsx("span", {
            className: style['old-price'],
            children: oldPrice
          })]
        }), /*#__PURE__*/_jsx(UIText2, {
          color: "current_color",
          whiteSpace: "nowrap",
          children: description
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: style['labels'],
        children: [isBooked && /*#__PURE__*/_jsx(Label, {
          background: "accent-ghost-primary",
          color: "text-inverted-default",
          children: "\u0417\u0430\u0431\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0430"
        }), hasDecoration && /*#__PURE__*/_jsx("div", {
          className: style['description-labels'],
          children: /*#__PURE__*/_jsx(Label, {
            color: "text-primary-default",
            background: "surface-positive-disabled",
            children: "\u0421 \u043E\u0442\u0434\u0435\u043B\u043A\u043E\u0439"
          })
        }), discountLabel && /*#__PURE__*/_jsx(Label, {
          background: "accent-positive-secondary",
          color: "accent-positive-primary",
          children: discountLabel
        })]
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: style['actions'],
      children: /*#__PURE__*/_jsx(FavoriteButton, {
        initialFavoriteState: flat.isFavorite,
        offerId: flat.offerId
      })
    })]
  });
};